import React from "react";
import {
  ItemListadoMascotasReservas,
  useListarMascotasReservasGuarderia,
} from "../../../../services/reservasGuarderiaServicios";
import TableSection from "./TableSection";
import ServerErrorModal from "../../../organisms/ServerErrorModal";
import { Model } from "../Model";
import DatosBasicos from "../DatosBasicos/DatosBasicos";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Row, Stack } from "react-bootstrap";
import SuccessButton from "../../../organisms/SuccessButton";
import { useWizard } from "../../../../hooks/wizard";
import { usePasoReservaGuarderia } from "../pasoReservaGuarderia";
import {
  buscarPropietario,
  QUERY_BUSCAR_PROPIETARIO,
  RespuestaBuscarPropietario,
} from "../../../../services/propietariosServicios";
import { useQuery } from "@tanstack/react-query";

function SeleccionMascota({ model }: { model: Model }) {
  const { avanza, avanzar } = useWizard();
  const { currentModel, seleccionarMascota, definirDatosPropietario } =
    usePasoReservaGuarderia(model);

  const {
    data: mascotas,
    isLoading: mascotasIsLoading,
    isSuccess: mascotasIsSuccess,
    error: mascotasError,
  } = useListarMascotasReservasGuarderia();

  const { error: errorDatosPropietario } =
    useQuery({
      queryKey: [QUERY_BUSCAR_PROPIETARIO],
      queryFn: async () => await buscarPropietario(currentModel.idPropietario),
      enabled: !!currentModel.idPropietario,
      onSuccess: (data: RespuestaBuscarPropietario) => {
        definirDatosPropietario({ datosPropietario: data });
      },
    });

  const puedeAvanzar =
    !!currentModel.idMascota && !!currentModel.datosPropietario;

  const error = mascotasError || errorDatosPropietario;

  const onSiguienteClick = () => {
    avanzar();
  };

  const onMascotaRowClick = (
    itemListadoMascotaReservas: ItemListadoMascotasReservas
  ) => {
    // Reiniciamos los valores de pasos siguientes, porque es posible avanzar y volver a pasos anteriores
    seleccionarMascota({
      idMascota: itemListadoMascotaReservas.id,
      nombreMascota: itemListadoMascotaReservas.nombre,
      idPropietario: itemListadoMascotaReservas.idPropietario,
      nombresPropietario: itemListadoMascotaReservas.nombresPropietario,
    });
  };

  if (error) {
    return <ServerErrorModal />;
  }

  if (avanza) {
    return <DatosBasicos model={currentModel} />;
  }

  return (
    <Stack gap={2} className="p-2">
      <section className="d-flex gap-2 mx-3">
        <h5>Mascota seleccionada: </h5>
        {!!currentModel.nombreMascota && <h5>{currentModel.nombreMascota}</h5>}
      </section>
      <TableSection
        items={mascotas || []}
        onRowClick={onMascotaRowClick}
        isLoading={mascotasIsLoading}
        isSuccess={mascotasIsSuccess}
        selectedIds={[currentModel.idMascota]}
      />
      <Row className="mb-2 justify-content-end">
        <SuccessButton
          type={"button"}
          style={{ width: "fit-content" }}
          disabled={!puedeAvanzar}
          onClick={onSiguienteClick}
        >
          Siguiente <ArrowForwardIcon sx={{ fontSize: 20 }} />
        </SuccessButton>
      </Row>
    </Stack>
  );
}

export default SeleccionMascota;
